<template>
  <div v-if="yearsToSelect" id="tax-docs-model-721">
    <v-card class="px-5 py-2 mt-4 mb-0 elevation-0">
      <v-chip-group v-model="yearSelected" active-class="primary" mandatory show-arrows>
        <v-chip
          v-for="year in yearsToSelect"
          :key="year"
          filter
          outlined
          :value="year"
          @click="yearClicked(year)"
        >
          {{ year }}
        </v-chip>
      </v-chip-group>
    </v-card>

    <SomePositionIncomplete />

    <v-card v-show="somePendingRecreatePosition" class="pa-4 pt-7 mt-4 elevation-0">
      <TaxSomePositionRecreating />
    </v-card>
    <v-row v-show="!somePendingRecreatePosition">
      <v-col cols="12" md="12" class="mt-4 py-0">
        <v-alert
          id="tax-guide-alert"
          color="softInfo"
          icon="mdi-information-outline"
          class="mb-0 mt-1"
        >
          Debes presentar el Modelo 721 si resides en España y tienes
          <b>más de 50.000 euros invertidos en criptomonedas</b>
          a día 31 de diciembre del año fiscal.
          <br />
          A continuación se muestra la situación de tu cartera de criptomonedas a día 31 de
          diciembre de
          {{ yearSelected }} para todos tus broker/wallets.
        </v-alert>
      </v-col>

      <v-col cols="12" md="12" class="mt-4 py-0">
        <PortfolioEndOfYear
          ref="portfolioEndOfYear"
          title="Cartera de criptomonedas a día 31 diciembre de "
          :year="yearSelected"
          :itemsPerPage="100"
          :showShowCashButton="false"
          :showCountry="false"
          :positionTypes="['crypto']"
          :hideDataNoPlanUser="hideDataNoPlanUser"
        />
      </v-col>

      <v-col cols="12" md="12" class="mt-6 py-3">
        <TaxDisclaimer />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getSummary } from '@/lib/api.js'
import taxMixin from '@/views/components/tax/taxMixin'
import PortfolioEndOfYear from '@/views/components/tax/taxSummary/PortfolioEndOfYear'

export default {
  components: {
    PortfolioEndOfYear,
  },
  mixins: [taxMixin],
  data: () => ({
    tab: 'model721',
  }),
  async mounted() {
    const portfolioAge = await getSummary({
      type: 'portfolio-age',
    })
    this.yearsToSelect = portfolioAge.data.map((elem) => {
      return elem.toString()
    })
    if (this.yearsToSelect.length >= 2) {
      this.yearSelected = this.yearsToSelect[this.yearsToSelect.length - 2]
    } else {
      this.yearSelected = this.yearsToSelect[this.yearsToSelect.length - 1]
    }
  },
  methods: {
    loadData() {
      if (this.$refs.portfolioEndOfYear) this.$refs.portfolioEndOfYear.init()
    },
  },
}
</script>

<style lang="scss">
#tax-docs-model-721 {
  .row-total td {
    font-size: 17px !important;
    font-weight: 600 !important;
    .strong {
      font-weight: 600 !important;
    }
  }
}
</style>
